import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureConstructionProfile } from "../../../hooks/Capture";
import ConstructionProfiles from "../ConstructionProfile/ConstructionProfiles";

interface ConstructionProfileTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const ConstructionProfileTab: React.FC<ConstructionProfileTabProps> = ({ captureId, handleError, canEdit }) => {
  const { constructionProfilesData, isPending, createConstructionProfile, updateConstructionProfile, deleteConstructionProfile } = useCaptureConstructionProfile(captureId);

  if (isPending && constructionProfilesData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ConstructionProfiles
      constructionProfilesData={constructionProfilesData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createConstructionProfile(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateConstructionProfile({ profileId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteConstructionProfile(id).catch(handleError);
      }}
    />
  );
};

export default ConstructionProfileTab;
